import React, { useState, useEffect } from "react";

import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";

import { connect } from "react-redux";

import DeliveryIcon from "../../../media/delivery.png";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";

import { getDeliveringOrders } from "../../../actions/sellerActions";
import Loading from "../../Loading";

const DeliveringOrders = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      props.getDeliveringOrders(props.auth.seller._id);
    }
  }, [props.auth.isAuthenticated]);

  useEffect(() => {
    if (props.deliveringOrders) {
      setData(props.deliveringOrders);
      setLoading(false);
    }
  }, [props.deliveringOrders]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <div
        style={{
          backgroundColor: "green",
          color: "white",
          padding: "1px 0 1px 30px",
          margin: "10px 0",
          borderRadius: "10px",
        }}
      >
        <div style={{ display: "flex",alignItems:'center' }}>
          <img
            src={DeliveryIcon}
            height="40px"
            width="40px"
            style={{ marginRight: 10 }}
            alt="Order List Icon"
          />
          <h3>Delivering Orders</h3>
        </div>
      </div>
      {!loading && (data.length === 0 || !data) ? (
        <div style={{ display: "flex" }}>
          <HourglassEmptyIcon style={{ margin: "20px 20px 20px 0" }} />
          <h3>No Order To Deliver</h3>
        </div>
      ) : (
        <Grid container spacing={2}>
          {data.map((Order, index) => {
            const { buyer, order, location } = Order;
            return (
              <Grid item xs={12} md={6} lg={4}>
                <Card variant="outlined">
                  <CardContent
                    style={{ padding: "10px 0", backgroundColor: "bisque" }}
                  >
                    <>
                      <Typography
                        variant="h6"
                        style={{ marginLeft: "15px", color: "black" }}
                      >
                        {buyer.name}
                      </Typography>
                      <div>
                        <Table className="table">
                          <TableHead>
                            <TableRow>
                              <TableCell></TableCell>
                              <TableCell className="bigDevices">
                                <b>Items</b>
                              </TableCell>
                              <TableCell numeric>
                                <b>Quantity</b>
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          {order.map((arder) => {
                            const { item, quantity } = arder;
                            return (
                              <TableBody>
                                <TableRow>
                                  <TableCell>
                                    <img
                                      src={item.images[0]}
                                      style={{
                                        width: "75px",
                                        borderRadius: "13%",
                                      }}
                                      alt="ItemImage"
                                    />
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className="bigDevices"
                                  >
                                    {item.name}
                                  </TableCell>
                                  <TableCell numeric>{quantity}</TableCell>
                                </TableRow>
                              </TableBody>
                            );
                          })}
                        </Table>
                      </div>
                      // todo: update coordinates to location
                      <p style={{ textAlign: "center", color: "black" }}>
                        <b>Address:</b> {location.coordinates}
                      </p>
                    </>
                  </CardContent>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  deliveringOrders: state.server.deliveringOrders,
});

export default connect(mapStateToProps, {
  getDeliveringOrders,
})(DeliveringOrders);
